// extracted by mini-css-extract-plugin
module.exports = {"container":"Modals_container__3Komn","instructionsBox":"Modals_instructionsBox__r9N05"};